import type { Route } from "next"

export const siteConfig = {
  name: "Adriano Corbelino II",
  title: "Adriano Corbelino II",
  description:
    "Adriano Corbelino II — Brazilian computer scientist and CS PhD student researching programming languages, type theory, and formal verification.",
  url: "https://www.adrianocorbelinoii.com",
  email: "adrianocorbelinoii@gmail.com",
} as const

export const about = {
  greeting: "Hello There!",
  // **word** marks a gold highlight; [text](url) becomes a rose link.
  bio: [
    "I am Adriano, a Computer Science PhD student at the **University of Massachusetts Lowell**, advised by [Prof. Paul Downen](https://pauldownen.com/).",
    "My research explores how we can merge programming paradigms — using **codata** to bridge the gap between the **functional** and **object-oriented** worlds. If that sounds interesting, check out my current project **CoPy**, which takes the converse route and brings **copatterns** to Python.",
  ],
  findMe: "You can find me on",
} as const

export const cv = {
  // Authored in cv/cv.qmd (Quarto); `cv/build.sh` regenerates the PDF below
  // and the injected HTML fragment at src/content/cv.generated.html.
  pdfUrl: "/cv_adrianoii.pdf",
  email: "adriano_vilargacorbelino@uml.edu",
  location: "Lowell, MA, USA",
  links: [
    { label: "GitHub", href: "https://github.com/AdrianoII" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/adrianoii/" },
  ],
} as const

// semester as "<Season> <Year>", e.g. "Fall 2020". Season is one of
// Spring/Summer/Fall/Winter — the page sorts by it, so spelling matters.
export type Season = "Spring" | "Summer" | "Fall" | "Winter"
export type CourseSlug = "comp-3010"
export type TeachingClass = {
  readonly course: string
  readonly semester: `${Season} ${number}`
  // if set, the course links to its own page at /teaching/<slug>; add the
  // slug here when you add the page so hrefs stay type-checked
  readonly slug?: CourseSlug
}

export const teaching = {
  role: "Instructor of Record",
  institution: "University of Massachusetts Lowell",
  location: "Lowell, MA, USA",
  // The page groups + sorts by semester, so order here doesn't matter and a
  // course may repeat across terms (just add more rows).
  classes: [
    {
      course: "COMP.3010 Organization of Programming Languages",
      semester: "Summer 2026",
      slug: "comp-3010",
    },
  ],
} as const satisfies {
  role: string
  institution: string
  location: string
  classes: readonly TeachingClass[]
}

// `Route` comes from Next's typedRoutes: every href must be a real page.
export type NavItem = {
  readonly href: Route
  readonly label: string
}

export const navItems = [
  { href: "/", label: "About" },
  { href: "/projects", label: "Projects" },
  { href: "/teaching", label: "Teaching" },
  { href: "/cv", label: "CV" },
] as const satisfies readonly NavItem[]


export type SocialLink = {
  readonly label: string
  readonly title: string
  readonly href: string
  readonly icon: "mail" | "github" | "linkedin"
}

export const socialLinks = [
  {
    label: "Email",
    title: "My Email",
    href: `mailto:${siteConfig.email}`,
    icon: "mail",
  },
  {
    label: "GitHub",
    title: "My GitHub Profile",
    href: "https://github.com/AdrianoII",
    icon: "github",
  },
  {
    label: "LinkedIn",
    title: "My LinkedIn Profile",
    href: "https://www.linkedin.com/in/adrianoii/",
    icon: "linkedin",
  },
] as const satisfies readonly SocialLink[]
